var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:_vm.classNames,attrs:{"type":_vm.type,"disabled":_vm.disabled || _vm.isLoading,"tabindex":"0"},on:{"click":_vm.onClick}},[_c('span',[(_vm.isLoading)?_c('Spinner',{attrs:{"size":"sm"}}):_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }